export default {
  eventNotExist: (eName) => `This "${eName}" event name (eName) doesn't exist. Please use right event name`,
};
